import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { Check, ShieldCheck, ArrowRight, Lock, CreditCard, Zap } from 'lucide-react';
import { motion } from 'framer-motion';
export function OfferSection() {
  const [selected, setSelected] = useState<'pro' | 'elite'>('elite');
  const links = {
    pro: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBPddgkVSw5kWEgAQ5MFOM/es-ar?_r=AQABNvEyhY79duVidBKvbVmtk3f0r_-hyWsy75SMpZZnxzk&cart_link_id=CGnhwqWr&preview_theme_id=151828791463',
    elite: 'https://salud-en-tu-plato.myshopify.com/checkouts/cn/hWNBPdxVgHbVig9cN0izaXmk/es-ar?_r=AQAB28ywLZNyKfRUg1S9Z3xafHoe-sFeXzCYcxU_cNLeYJc&cart_link_id=sZWTrZ3E&preview_theme_id=151828791463'
  };
  const ctaText = {
    pro: '→ SÍ, QUIERO EL MEGAPACK NUTRI DEPORTIVA',
    elite: '→ SÍ, QUIERO EL MEGAPACK NUTRI DEPORTIVA + CONSULTORIO PRO™'
  };
  return <section id="comprar" className="px-3 py-10 bg-black" data-id="element-155">
      <div className="max-w-[680px] mx-auto" data-id="element-156">
        <FadeIn className="text-center mb-6" data-id="element-157">
          <h2 className="text-2xl md:text-4xl font-bold text-white mb-2" data-id="element-158">
            Elegí tu{' '}
            <span className="text-accent" data-id="element-159">Megapack Nutri Deportiva</span>
          </h2>
          <p className="text-base text-white/60" data-id="element-160">
            Las dos opciones incluyen acceso inmediato y bonos completos
          </p>
        </FadeIn>

        <div className="space-y-3 mb-5" data-id="element-161">
          {/* Card 1: Megapack */}
          <FadeIn delay={0.1} data-id="element-162">
            <div onClick={() => setSelected('pro')} className={`relative bg-black rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all group ${selected === 'pro' ? 'border-2 border-accent shadow-[0_0_30px_rgba(168,216,48,0.2)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-163">
              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'pro' ? 'border-accent' : 'border-white/20 group-hover:border-accent/50'}`} data-id="element-164">
                <div className={`w-3 h-3 rounded-full ${selected === 'pro' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-165" />
              </div>

              <div className="flex-1 min-w-0" data-id="element-166">
                <h3 className={`${`text-lg md:text-xl font-bold mb-1 ${selected === 'pro' ? 'text-accent' : 'text-white'}`} font-[900] font-[Poppins,_sans-serif]`} data-id="element-167">
                  MEGAPACK NUTRI DEPORTIVA
                </h3>
                <p className="text-white/50 text-sm md:text-base" data-id="element-168">
                  Acceso al Megapack Nutri Deportiva + bonos
                </p>
              </div>

              <div className="text-right shrink-0" data-id="element-169">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-170">
                  $34.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'pro' ? 'text-accent' : 'text-white'}`} data-id="element-171">
                  $19.990
                </p>
              </div>
            </div>
          </FadeIn>

          {/* Card 2: Plus (Highlighted) */}
          <FadeIn delay={0.2} data-id="element-172">
            <div onClick={() => setSelected('elite')} className={`relative bg-black rounded-xl p-4 md:p-6 flex items-center gap-3 md:gap-5 cursor-pointer transition-all ${selected === 'elite' ? 'border-2 border-accent shadow-[0_0_30px_rgba(168,216,48,0.2)]' : 'border border-accent/25 hover:border-accent/50'}`} data-id="element-173">
              <div className="absolute -top-3 left-6 flex items-center gap-2" data-id="element-174">
                <span className="bg-accent text-black text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-175">
                  MÁS ELEGIDO
                </span>
                <span className="text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider bg-accent/80" data-id="element-176">
                  AHORRÁS $16.000
                </span>
              </div>

              <div className={`shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center ${selected === 'elite' ? 'border-accent' : 'border-white/20'}`} data-id="element-177">
                <div className={`w-3 h-3 rounded-full ${selected === 'elite' ? 'bg-accent' : 'bg-transparent'}`} data-id="element-178" />
              </div>

              <div className="flex-1 min-w-0 pt-2" data-id="element-179">
                <h3 className={`${`${`text-lg md:text-xl font-bold mb-1 leading-tight ${selected === 'elite' ? 'text-accent' : 'text-white'}`} font-[900] font-['Open_Sans',_sans-serif]`} font-[700]`} data-id="element-180">
                  MEGAPACK NUTRI DEPORTIVA + CONSULTORIO PRO™
                </h3>
                <p className="text-white/60 text-sm md:text-base" data-id="element-181">
                  Incluye el Megapack Nutri Deportiva + Consultorio Pro™
                </p>
              </div>

              <div className="text-right shrink-0 pt-2" data-id="element-182">
                <p className="text-white/40 line-through text-sm mb-0.5" data-id="element-183">
                  $43.990
                </p>
                <p className={`text-2xl md:text-3xl font-bold ${selected === 'elite' ? 'text-accent' : 'text-white'}`} data-id="element-184">
                  $27.990
                </p>
              </div>
            </div>
          </FadeIn>
        </div>

        {/* Main CTA */}
        <FadeIn delay={0.3} className="text-center mb-5" data-id="element-185">
          <motion.a href={links[selected]} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="block w-full bg-accent hover:bg-accent/90 text-black font-bold md:text-xl py-5 px-8 rounded-xl shadow-lg shadow-accent/20 transition-all text-center text-[16px]" data-id="element-186">
            {ctaText[selected]}
          </motion.a>
          <p className="text-white/50 text-xs mt-3 italic" data-id="element-187">
            La opción más elegida por quienes quieren avanzar más rápido y
            cobrar mejor
          </p>
        </FadeIn>

        {/* Trust Bar */}
        <FadeIn delay={0.4} className="mb-10" data-id="element-188">
          <div className="flex flex-wrap justify-center gap-4 md:gap-6 bg-surface border border-accent/25 rounded-lg py-3 px-4" data-id="element-189">
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-190">
              <Lock size={16} className="text-accent" data-id="element-191" />
              Pago seguro
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-192">
              <Zap size={16} className="text-accent" data-id="element-193" />
              Acceso inmediato
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-194">
              <ShieldCheck size={16} className="text-accent" data-id="element-195" />
              Garantía 7 días
            </div>
            <div className="flex items-center gap-2 text-white/60 text-sm font-medium" data-id="element-196">
              <CreditCard size={16} className="text-accent" data-id="element-197" />
              Mercado Pago
            </div>
          </div>
        </FadeIn>

        {/* Módulos Consultorio Pro™ */}
        <FadeIn delay={0.6} data-id="element-198">
          <div className="bg-surface border border-accent/25 rounded-xl p-4 mb-6" data-id="element-199">
            <h3 className="text-lg font-bold text-accent mb-3 text-center" data-id="element-200">
              🏥 Qué agrega el Consultorio Pro™
            </h3>
            <ul className="space-y-2" data-id="element-201">
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-202">
                <span className="shrink-0" data-id="element-203">🟢</span>
                <span data-id="element-204">
                  <strong className="text-white" data-id="element-205">Módulo 1:</strong> Bases de la
                  nutrición deportiva infantil
                  <p className="text-white/50 text-xs mt-0.5" data-id="element-206">
                    Requerimientos energéticos, macros y micros clave según edad
                    y etapa de crecimiento.
                  </p>
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-207">
                <span className="shrink-0" data-id="element-208">🟡</span>
                <span data-id="element-209">
                  <strong className="text-white" data-id="element-210">Módulo 2:</strong> Alimentación
                  según deporte
                  <p className="text-white/50 text-xs mt-0.5" data-id="element-211">
                    Cómo adaptar el plan nutricional a deportes de fuerza,
                    resistencia, equipo y combate.
                  </p>
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-212">
                <span className="shrink-0" data-id="element-213">🟠</span>
                <span data-id="element-214">
                  <strong className="text-white" data-id="element-215">Módulo 3:</strong> Colaciones y
                  menús para rendimiento
                  <p className="text-white/50 text-xs mt-0.5" data-id="element-216">
                    Ejemplos prácticos de snacks pre/post entreno y menús
                    semanales listos para usar.
                  </p>
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-217">
                <span className="shrink-0" data-id="element-218">🔴</span>
                <span data-id="element-219">
                  <strong className="text-white" data-id="element-220">Módulo 4:</strong> Hidratación
                  y suplementación segura
                  <p className="text-white/50 text-xs mt-0.5" data-id="element-221">
                    Protocolos de hidratación y criterios para evaluar
                    suplementos en población pediátrica.
                  </p>
                </span>
              </li>
              <li className="flex items-start gap-2 text-white/80 text-sm" data-id="element-222">
                <span className="shrink-0" data-id="element-223">⭐</span>
                <span data-id="element-224">
                  <strong className="text-white" data-id="element-225">Módulo 5:</strong> Casos
                  clínicos y guías para padres
                  <p className="text-white/50 text-xs mt-0.5" data-id="element-226">
                    Resolución de casos reales y material educativo para
                    entregar a las familias.
                  </p>
                </span>
              </li>
            </ul>
          </div>
        </FadeIn>

        {/* Objections */}
        <FadeIn delay={0.6} data-id="element-227">
          <div className="grid md:grid-cols-3 gap-4" data-id="element-228">
            <div className="bg-surface border border-accent/25 p-4 rounded-xl" data-id="element-229">
              <h4 className="font-bold text-accent mb-2" data-id="element-230">
                ¿Y si soy recién recibido?
              </h4>
              <p className="text-white/70 text-sm" data-id="element-231">
                Te da la estructura y seguridad que la facultad no te dio para
                tu primera consulta deportiva. Entrás con ventaja.
              </p>
            </div>
            <div className="bg-surface border border-accent/25 p-4 rounded-xl" data-id="element-232">
              <h4 className="font-bold text-accent mb-2" data-id="element-233">
                ¿Y si ya tengo experiencia?
              </h4>
              <p className="text-white/70 text-sm" data-id="element-234">
                Te ahorra horas de armado de protocolos y te da un sistema
                pulido para escalar atletas complejos sin quemarte la cabeza.
              </p>
            </div>
            <div className="bg-surface border border-accent/25 p-4 rounded-xl" data-id="element-235">
              <h4 className="font-bold text-accent mb-2" data-id="element-236">¿Y si no me sirve?</h4>
              <p className="text-white/70 text-sm" data-id="element-237">
                Tenés 7 días de garantía total. Si sentís que no te suma valor
                profesional, te devolvemos el dinero sin hacer preguntas.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}